import enMessages from './src/intl/messages/en_US.json';
import nbMessages from './src/intl/messages/nb_NO.json';
import nnMessages from './src/intl/messages/nn_NO.json';

export const uiMessages = {
    nb: nbMessages,
    nn: nnMessages,
    en: enMessages,
};

export { SkjemaRotLayout } from './src/skjema-rotlayout/SkjemaRotLayout';
export { ErrorBoundary } from './src/error/ErrorBoundary';
export { ErrorSummaryFelles } from './src/error/ErrorSummaryFelles';
export { SimpleErrorPage } from './src/error/SimpleErrorPage';
export type { ErrorSummaryError } from './src/error/ErrorSummaryFelles';
export { ErrorPage } from './src/error/ErrorPage';
export { StepButtons } from './src/step/StepButtons';
export { ScanDocumentInfo } from './src/scan-document-info/ScanDocumentInfo';
export { HorizontalLine } from './src/horizontal-line/HorizontalLine';
export { Umyndig } from './src/umyndig/Umyndig';
export { IntlProvider } from './src/intl/IntlProvider';
export { Step } from './src/step/page-step/Step';
export { StepFooter } from './src/step/page-step/step-footer/StepFooter';
export { ProgressStepper } from './src/step/progress-stepper/ProgressStepper';
export { Card } from './src/card/Card';
export type { CardProps } from './src/card/Card';
export { CardIconCircle } from './src/card/CardIconCircle';
export { CardEmptyIndicator } from './src/card/CardEmptyIndicator';
export { CardBadge } from './src/card/CardBadge';
export { CardChip } from './src/card/CardChip';
export { CardLabel } from './src/card/CardLabel';
export { CardDate } from './src/card/CardDate';
export { CardBody } from './src/card/CardBody';
export { CardActions } from './src/card/CardActions';
export type { CardSize, CardTone, CardStateTone } from './src/card/types';
export { Calendar } from './src/calendar/Calendar';
export { CalendarLabel } from './src/calendar/label/CalendarLabel';
export type { CalendarPeriodColor } from './src/calendar/types/CalendarPeriodColor';
export type { CalendarPeriod } from './src/calendar/types/CalendarPeriod';
export type { ProgressStep } from './src/step/progress-stepper/ProgressStepper';
export { Page } from './src/page/Page';
export { BlueHeading } from './src/boxes/BlueHeading';
export { BluePanel } from './src/boxes/BluePanel';
export { Infobox } from './src/boxes/Infobox';
export { IconCircleWrapper } from './src/icon-circle/IconCircleWrapper';
export { VeiviserPage } from './src/veivisere/VeiviserPage';
export { FrontPage } from './src/veivisere/frontpage/FrontPage';
export { RegisterdataUtdatert } from './src/registerdata-utdatert/RegisterdataUtdatert';
export { Spinner } from './src/loaders/Spinner';
export { Slider } from './src/slider/Slider';
export { PeriodLabel } from './src/period-label/PeriodLabel';
export { SamtykkePanel } from './src/samtykke-panel/SamtykkePanel';
export { DekningsgradUtbetalingEksempel } from './src/dekningsgrad-utbetaling-eksempel/DekningsgradUtbetalingEksempel';
export { KvoteProgresjonRing } from './src/kvote-progresjon-ring/KvoteProgresjonRing';
export type {
    KvoteProgresjonRingProps,
    KvoteTone,
    KvoteRingSize,
    KvoteProgresjonRingSplitInfo,
} from './src/kvote-progresjon-ring/KvoteProgresjonRing';
export { InfoboksMedIkon } from './src/infoboks-med-ikon/InfoboksMedIkon';
